module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sZ6LNy/tc-custom/9781452146331.jpg?1723000508340",
      "alt": "This image is the cover for the book Here Kitty Kitty"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Here Kitty Kitty\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A cat-tastic collection of quirky illustrations and amusing quotes that capture the delightful (yet sometimes peculiar) realities of feline friendship. ")])]), _vm._v(" This charming book of whimsical illustrations is sure to win over even the most finicky cat lover. Brimming with colorful contemporary artwork by today’s up-and-coming indie art and illustration darlings, and sprinkled throughout with quotations from famous folks celebrating the traits and quirks of their favorite furry friends, this fanciful and playful little volume offers kittenish delight on every page—making it the perfect just-because gift for cat lovers everywhere. Featuring dancing cats, snarky cats, musical cats, sleepy cats, cunning cats, cranky cats, cuddly cats, and dapper cats, there’s a kitty for everyone in this treasury of heartwarming feline fun. \n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mallory McInnis\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0